import { ResponseData } from '@freelancer/datastore';
import {
  AuthResponseAjax,
  TwoFactorResponseAjax,
} from './login-signup.backend-model';
import { AuthResponse, TwoFactorResponse } from './login-signup.model';

export function transformResponseData<T, U, E>(
  responseData: ResponseData<T, E>,
  transform: (obj: T) => U,
): ResponseData<U, E> {
  if (responseData.status === 'error') {
    return responseData;
  }
  return {
    ...responseData,
    result: transform(responseData.result),
  };
}

export function transformAuthResponse(
  response: AuthResponseAjax,
): AuthResponse {
  if ('pre_login_token' in response) {
    return transformTwoFactorResponse(response);
  }
  return response;
}

export function transformTwoFactorResponse(
  response: TwoFactorResponseAjax,
): TwoFactorResponse {
  return {
    preLoginToken: response.pre_login_token,
    message: response.message,
  };
}
